<kendo-dialog title="Se déconnecter" *ngIf="dialogOpened" (close)="close()" [minWidth]="250" [width]="450">
  <p style="margin: 30px; text-align: center;">Êtes-vous sûr de vous déconnecter?</p>
  <p style="margin: 30px; text-align: center; font-weight: bold;" *ngIf="dialogErrorMessage">
    {{ dialogErrorMessage }}
  </p>
  <kendo-dialog-actions>
    <button kendoButton (click)="action('no')" [disabled]="loadingRequest">Non</button>
    <button kendoButton (click)="action('yes')" [primary]="true" class="primary-color" [disabled]="loadingRequest">
      <ng-container *ngIf="!loadingRequest; else loading">
        Oui
      </ng-container>
      <ng-template #loading>
        Envoi...
      </ng-template>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
